export default __webpack_public_path__ + "static/media/p2-4.a9a21dc1.png";